export interface INavigationRoute {
  name: string
  displayName: string
  meta: { icon: string }
  children?: INavigationRoute[]
}

export default {
  root: {
    name: '/',
    displayName: 'navigationRoutes.home',
  },
  routes: [
    {
      name: 'dashboard',
      displayName: 'menu.dashboard',
      meta: {
        icon: 'vuestic-iconset-dashboard',
      },
    },
    {
      name: 'tenants',
      displayName: 'menu.tenants',
      meta: {
        icon: 'domain',
      },
    },
    {
      name: 'packages',
      displayName: 'menu.packages',
      meta: {
        icon: 'task',
      },
    },
    {
      name: 'apiPermissions',
      displayName: 'Yetki Yönetimi',
      meta: {
        icon: 'security',
      },
    },
    {
      name: 'tenantReviews',
      displayName: 'menu.tenantReviews',
      meta: {
        icon: 'mso-rate_review',
      },
    },
    {
      name: 'subscriptionRequests',
      displayName: 'Abonelik Talepleri',
      meta: {
        icon: 'mso-payments',
      },
    },
    {
      name: 'systemSettings',
      displayName: 'Sistem Ayarları',
      meta: {
        icon: 'settings',
      },
    },
  ] as INavigationRoute[],
}
